<template>
  <div class="google-map" :id="mapName"></div>
</template>

<script>
export default {
  name: 'google-map',
  props: ['name', 'showing', 'listingdata', 'filter'],
  data: function () {
    return {
      listings: this.listingdata,
      mapName: this.name + '-map',
      getCoordinates: function () {
        this.listings.forEach((listing) => {
          this.markerCoordinates.push({latitude: listing.LA, longitude: listing.LO, index: listing.HN})
        })
      },
      markerCoordinates: [],
      map: null,
      bounds: null,
      markers: []
    }
  },
  methods: {
    showListing: function (marker) {
      let cards = document.querySelectorAll('.listing-card')
      for (let i = 0; i < cards.length; i++) {
        cards[i].classList.remove('highlight')
      }
      this.$parent.toggle()
      let card = document.getElementById(marker.label.text)
      setTimeout(function () { card.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'}) }, 250)
      card.children[0].classList.add('highlight')
    },
    addMarkers: function () {
      if (this.filter[0] || this.filter.length > 1) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null)
          if (this.filter.includes(this.markers[i].label.text)) {
            let marker = this.markers[i]
            marker.setAnimation(google.maps.Animation.DROP)
            marker.setMap(this.map)
            this.map.setCenter(marker.getPosition())
          }
          this.filter.length < 3 ? this.map.setZoom(14) : this.map.fitBounds(this.bounds)
        }
      } else {
        this.map.setCenter(this.markers[0].getPosition())
        this.map.fitBounds(this.bounds)
        this.markers.forEach(marker => marker.setMap(this.map))
      }
    }
  },
  watch: {
    filter: 'addMarkers'
  },
  mounted: function () {
    this.bounds = new google.maps.LatLngBounds()
    const element = document.getElementById(this.mapName)
    this.getCoordinates()
    const mapCenter = this.markerCoordinates[0]
    const options = {
      center: new google.maps.LatLng(mapCenter.latitude, mapCenter.longitude),
      mapTypeControl: false,
      fullscreenControl: false
    }
    this.map = new google.maps.Map(element, options)
    this.markerCoordinates.forEach((coord) => {
      const position = new google.maps.LatLng(coord.latitude, coord.longitude)
      const marker = new google.maps.Marker({
        position,
        label: {text: coord.index, color: 'white'},
        map: this.map,
        icon: {url: require('@/assets/map-icon.png'), labelOrigin: {x: 12, y: 14}}
      })
      marker.addListener('click', () => this.showListing(marker))
      this.markers.push(marker)
      this.map.fitBounds(this.bounds.extend(position))
    })
    let controlDiv = document.getElementById('mapControl')
    let favoriteControl = document.getElementById('showFavorites')
    let titleDiv = document.getElementById('titleDiv')
    this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(favoriteControl)
    this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controlDiv)
  }
}
</script>

<style scoped>
  .google-map {
    width: 100%;
    height: 100%;
    background: gray;
  }
</style>




// WEBPACK FOOTER //
// src/components/GoogleMap.vue